var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"scroll-wrapper",attrs:{"height":"100%"}},[_c('iframe',{attrs:{"src":_vm.url,"loading":"lazy","frameborder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }